module.exports = __webpack_public_path__ + "static/IBMPlexMono700-b92716c44d0ec4bb256f9eda1e5c9999.woff2";